<template>
  <!-- 音频标注 -->
  <div class="dataset-audio-annotation">
    <div class="pretrain-header header">
      <h3 class="title">音频标注</h3>
    </div>
    <div class="main">
      <div class="dataset-get">
        <div class="tool-wrap">
          <div class="select-tool">
            <span class="label">
              <i class="required">*</i>
              选择数据集：
            </span>
            <el-select
              class="select-box"
              v-model="datasetName"
              placeholder="请选择"
              filterable
              :disabled ="originTemp=='modelList'"
            >
              <el-option
                v-for="item in datasetOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select-tool">
            <span class="label">
              <i class="required">*</i>
              选择数据集版本：
            </span>
            <el-select
              class="select-box"
              v-model="activeDataset"
              placeholder="请选择"
              filterable
              :disabled="originTemp == 'modelList'"
            >
              <el-option
                v-for="item in versionList"
                :key="item.datasetId"
                :label="item.version"
                :value="item.datasetId"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="bnts-tag">
        <button
          v-for="(opt, idx) in filterOptions.items"
          :class="[
            'btn-default',
            opt.name == filterOptions.filtered ? 'active' : '',
          ]"
          @click="getFilterType(opt.name)"
          :key="idx"
        >
          {{ opt.label }}
        </button>
        <!-- 提示语 -->
        <el-alert title="* 每个标签下的音频片段数量不少于20个" type="error">
        </el-alert>

        <!-- 音频上传按钮 -->
        <el-button
          type="primary"
          class="quote-upload btn-primary"
           :class="{ 'events-disable': isRelease == 1 }"
          @click="quoteDataset"
          v-show="activeDataset"
          >引用数据集</el-button
        >
        <el-button
          type="primary"
          class="btn-upload btn-primary"
           :class="{ 'events-disable': isRelease == 1 }"
          @click="uploadPictures"
          v-show="activeDataset"
          >本地上传</el-button
        >
      </div>
      <!-- 音频累计 -->
      <span class="dataset-pic-total">
        {{
          filterOptions.filtered === 'tag'
            ? `累计${Pictures.total}个音频`
            : `累计${Pictures.total}个音频，${getTagLabelIdsNum}个音频片段`
        }}
      </span>
      <div class="group-tag">
        <a
          v-for="(item, idx) in filterOptData.data"
          :class="[
            'h-tag',
            filterOptions.items[filterOptions.filtered].filteredId.indexOf(
              item.id
            ) > -1
              ? 'active'
              : '',
          ]"
          href="javascript:void(0);"
          @click="getFilterDetails(item.id)"
          :key="idx"
        >
          <span class="title"> {{ item.label }} </span>
        </a>
      </div>

      <div class="picture-box" v-show="display === 'picture'">
        <ul class="pictures">
          <li
            class="picture-item"
            v-for="(item, idx) in Pictures.records"
            :key="item.audioId || idx"
          >
            <i
              class="el-icon-edit-outline preview-position"
              @click="onPreviewPosition(item.audioId, idx)"
              title="编辑"
            ></i>
            <i
              class="icon-caret-preview"
              @click="onFilePreview(item.audioUrl)"
              title="预览"
            ></i>
            <figure>
              <img src="../../assets/images/audioImage@2x.png" alt="" />
            </figure>
            <div class="btns" v-if ="isRelease != 1">
              <button
                class="btn-delete"
                :class="{ 'events-disable': isRelease == 1 }"
                @click="activeDeletePopup(item.audioId, idx)"
              >
                删除
              </button>
              <button
                class="btn-primary"
                :class="{ 'events-disable': isRelease == 1 }"
                @click="activeRenamePopup(item.audioId, item.audioName, idx)"
              >
                重命名
              </button>
            </div>
            <div class="title ellipsis" :title="item.audioName">
              {{ item.audioName }}
            </div>
          </li>
        </ul>
        <!-- 分页 -->
        <div class="pagination">
          <el-pagination
            @current-change="handleCurrentChange"
            background
            :current-page.sync="currentPage"
            :page-size="20"
            :pager-count="5"
            layout="slot, prev, pager, next"
            :total="this.Pictures.total"
            :hide-on-single-page="true"
          >
          </el-pagination>
        </div>
        <!-- 分割线 -->
        <div class="sep" title="切换到音频标注处理">
          <span class="switch" @click="switchDisplayMode">
            <i :class="['el-icon-d-arrow-right', display]"></i>
          </span>
        </div>
      </div>
      <div class="label-box" v-show="display === 'label'">
        <!-- 音频滑动 -->
        <audio-slider
          class="picture-slider"
          :pictures="this.Pictures.records"
          :active-image="activeImage"
          @prev="sliderPrev"
          @next="sliderNext"
          @image-click="sliderImageHandle"
        />
        <!-- 分割线 -->
        <div class="sep" title="切换到音频查看管理">
          <span class="switch" @click="switchDisplayMode">
            <i :class="['el-icon-d-arrow-right', display]"></i>
          </span>
        </div>
        <div class="label-content">
          <!-- 音频标注区 -->
          <audio-annotation-area
            :annotationsList="annotationsList"
            :regionAudio="regionAudio"
            :labelList="Label.records"
            :isRelease ="isRelease"
            :origin="origin"
            ref="labelRegion"
          ></audio-annotation-area>
          <!-- 标签区 -->
          <div class="label-tag">
            <div class="top">
              <div class="title">标签</div>
              <button
                class="add-tag"
                :class="{ 'events-disable': isRelease == 1 }"
                @click="activeAddTagPopup('添加标签')"
                title="添加标签"
              >
                +
              </button>
            </div>
            <div class="ipt">
              <el-input
                placeholder="搜索标签"
                v-model.trim="searchLabelName"
                @keyup.enter.native="onSearchLabel"
              >
                <i
                  slot="suffix"
                  class="icon-search-box"
                  @click="onSearchLabel"
                  title="搜索标签"
                >
                  <span class="el-icon-search"></span>
                </i>
              </el-input>
            </div>

            <div class="nav-checkbox">
              <ul>
                <li
                  v-for="item in navCheckList"
                  :key="item"
                  @click="onSelectNavState(item)"
                >
                  <!-- <i :class="[currentNavlabel === item ? 'el-icon-check i-select' : '']"></i> -->
                  <!-- <span :class="[currentNavlabel === item ? 'span-select' : '']">{{item}}</span> -->
                  <span>{{ item }}</span>
                </li>
              </ul>
            </div>

            <ul class="list-tags">
              <li
                class="tag-list"
                :class="{ 'events-disable': isRelease == 1 }"
                v-for="(item, idx) in Label.records"
                @click="
                  addTagToCurrentRegion(item.labelName, item.labelId, item)
                "
                :key="idx"
                :style="{
                  background:
                    selentCurrentLabelId == item.labelId
                      ? 'rgba(76, 136, 255, 0.2)'
                      : '',
                }"
              >
                <i
                  :class="[item.labelState ? 'el-icon-check i-select' : '']"
                  @click.stop="onSelectLabel(item.labelId)"
                ></i>
                <!-- <span class="txt ellipsis" :title="item.labelName">{{ item.labelName }}</span> -->
                <tooltip-box
                  class="txt"
                  :textRef="'labelName'"
                  :textId="item.labelId"
                  :textRow="1"
                  :textName="item.labelName"
                  :placement="'top'"
                  :tooltipShow="false"
                ></tooltip-box>
                <!-- <button class="el-icon-zoom-in icon-search-popup" @click.stop="onDialogAnnotation(item.labelId)" :disabled="!item.labelState" title="搜索标注"></button> -->
                <div class="tools">
                  <!-- TODO:命名需要弹框 -->
                  <button
                    @click.stop="
                      activeRenameLabelPopup(idx, item.labelId, item.labelName)
                    "
                  >
                    <icon-base v-bind="Icons.edite">
                      <icon-label />
                    </icon-base>
                  </button>
                  <!-- TODO:删除会删除标记 -->
                  <button @click.stop="deleteLabelPopup(idx, item.labelId)">
                    <icon-base v-bind="Icons.delete">
                      <icon-delete />
                    </icon-base>
                  </button>
                </div>
              </li>
            </ul>
            <!-- 搜索标签弹窗 -->
            <div
              :class="[
                'search-annotation',
                dialogAnnotationShow ? 'transform-left' : '',
              ]"
            >
              <div
                class="el-icon-d-arrow-right putItAway-search-annotation"
                title="点击收起"
                @click="onDialogAnnotationShow"
              ></div>
              <div class="ipt">
                <el-input
                  placeholder="搜索标注"
                  v-model.trim="searchAnnotationName"
                  @keyup.enter.native="onSearchAnnotation"
                >
                  <i
                    slot="suffix"
                    class="icon-search-box"
                    title="点击搜索标注"
                    @click="onSearchAnnotation"
                  >
                    <span class="el-icon-search"></span>
                  </i>
                </el-input>
              </div>
              <i class="line"></i>
              <div class="search-annotation-content">
                <p v-if="searchAnnotationNameFlng">
                  共搜索{{ currentLabelList.length }}条结果
                </p>
                <p
                  v-for="(item, index) in currentLabelList"
                  :key="index"
                  @click="onCurrentTagValue(item.tagValue, item.textTagId)"
                >
                  <span :style="`background-color: ${item.labelColor};`">{{
                    item.tagValue
                  }}</span>
                </p>
              </div>
            </div>
            <el-button
              type="primary"
              class="btn-primary btn-save"
              :class="{ 'events-disable': isRelease == 1 }"
              @click="updateLabelTag"
            >
              保存
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹窗集 -->
    <div class="popup-list">
      <!-- 添加新标签 -->
      <gat-popup
        :class="['popup-add-tag', popupActive === 'add_tag' ? 'on' : 'off']"
        :title="labelPopupTitle"
        @cancel="cancelPopup"
        @confirm="addLabel"
      >
        <template v-slot:content>
          <div
            v-if="
              labelPopupTitle.indexOf('添加标签') !== -1 &&
                Label.records &&
                Label.records.length >= 15
            "
          >
            <p class="p-tip">
              单个数据集的标签数最多不超过15个哦~
            </p>
            <div class="button-row">
              <el-button type="primary" @click="cancelPopup"
                >我知道了</el-button
              >
            </div>
          </div>
          <div v-else>
            <el-input
              placeholder="新的标签命名"
              v-model.trim="tagName"
              maxlength="20"
              show-word-limit
            />
            <p
              class="tip-list"
              v-if="labelPopupTitle.indexOf('添加标签') !== -1"
            >
              <i class="required">*</i>单个数据集的标签数最多不超过15个。
            </p>
          </div>
        </template>
      </gat-popup>
      <!-- 删除 -->
      <gat-popup
        :class="[
          'popup-delete popup-delete-2',
          popupActive === 'delete' || popupActive === 'label_delete'
            ? 'on'
            : 'off',
        ]"
        :title="popupActive === 'delete' ? '删除音频' : '删除标签'"
        :primary-button="'删除'"
        @cancel="cancelPopup"
        @confirm="deletePicture"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span v-show="popupActive === 'label_delete'" class="title"
                >确定删除此标签及此标签全部音频标注吗？</span
              >
              <span v-show="popupActive === 'delete'" class="title"
                >确定删除此音频吗？</span
              >
            </div>
          </div>
        </template>
      </gat-popup>
      <!-- 重命名 -->
      <gat-popup
        :class="['popup-rename', popupActive === 'rename' ? 'on' : 'off']"
        :title="'重命名'"
        @cancel="cancelPopup"
        @confirm="renameOperate"
      >
        <template v-slot:content>
          <el-input
            placeholder="请输入重命名"
            v-model.trim="popupData.rename.value"
            maxlength="20"
            show-word-limit
          />
        </template>
      </gat-popup>
      <!-- 上传音频提示 -->
      <model-training-upload-tips
        :modelType="modelType"
        :popupActive="popupActive"
        @confirmUploadTip="confirmUploadTip"
        @cancelPopup="cancelPopup"
        @uploadNoTipChange="uploadNoTipChange"
      ></model-training-upload-tips>
      <!--文件预览-->
      <file-preview
        :modelType="modelType"
        :fileUrl="currentAudioUrl"
        :dialogvisibleview="dialogvisibleview"
        @onClickDialog="dialogvisibleview = false"
      ></file-preview>
      <!--引用数据集弹窗-->
      <dataset-popup
        :modelType="modelType"
        :modelDatasetName="datasetName"
        :modelDatasetId="activeDataset"
        :fileNumAll="Pictures.total"
        :drawerShow="drawerShow"
        @onDrawerShow="drawerShow = false"
        @getPictureList="getCurrentTabNavAudioList"
      ></dataset-popup>
    </div>
  </div>
</template>

<script>
import GatPopup from '@/components/common/GatPopup'
import IconInfoHelp from '@/components/icons/typography/InfoHelp'
import IconLabel from '@/components/icons/typography/ToolLabel'
import IconDelete from '@/components/icons/typography/PopupClose'

import AudioAnnotationArea from '@/components/pretrain/AudioAnnotationArea'
// import LabelRegion from '@/components/pretrain/LabelRegion'
import AudioSlider from '@/components/pretrain/AudioSlider'
import ModelTrainingUploadTips from '@/components/pretrain/ModelTrainingUploadTips.vue'
import FilePreview from '@/components/pretrain/FilePreview.vue'
import DatasetPopup from '@/components/pretrain/DatasetPopup.vue'
import TooltipBox from '@/components/common/TooltipBox'

import COMMON from '@/axios/common/common.js'
import PRETRAIN from '@/axios/pretrain/pretrain.js'

// import { debounce } from 'lodash' // 引入lodash数组函数方法

export default {
  name: 'dataset-audio-annotation',
  components: {
    GatPopup,
    IconInfoHelp,
    IconLabel,
    IconDelete,
    // LabelRegion,
    AudioSlider,
    AudioAnnotationArea,
    ModelTrainingUploadTips,
    FilePreview,
    DatasetPopup,
    TooltipBox,
  },
  mixins: [],
  props: [],
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 资源平台上传基地址
      currentAudioUrl: '', // 音频路径
      labelPopupTitle: '添加标签',
      tagName: '', // 添加标签名
      annotationsList: [], // 当前操作标签下所有标注
      selentCurrentLabelId: '',
      searchLabelName: '',
      dialogvisibleview: false,
      searchAnnotationName: '',
      dialogAnnotationShow: false,
      currentLabelId: '', // 当前标签id
      selectCondition: 0,
      currentLabelList: [], // 点击搜索标签下的标注列表
      onSpanlist: {}, // 搜索标注同一标注统计
      searchAnnotationNameFlng: false,
      DatasetList: [],
      activeDataset: '',
      versionList: [],
      origin: null,
      originTemp: null,
      datasetName: '',
      isRelease: null,
      Label: {
        records: [],
        current: 1,
        size: 30,
        total: 0,
      },
      activeLabel: [],
      Pictures: {
        records: null,
        size: 7,
        current: 1,
        total: 0,
      },
      activeImage: void 0,
      filterOptions: {
        filtered: 'tag',
        items: {
          tag: {
            name: 'tag',
            label: '标注状态',
            filteredId: [2],
            data: [
              {
                id: 2,
                label: '全部音频',
              },
              { id: 1, label: '已标注' },
              { id: 0, label: '未标注' },
            ],
          },
          label: {
            name: 'label',
            label: '标签筛选',
            filteredId: [],
            data: [
              // {
              //   id: 1,
              //   label: "猫"
              // },
            ],
          },
        },
      },
      // 当前音频是否标注了无目标
      noTarget: false,
      currentPage: 1, // 分页器当前页面
      currentPositionIndex: 0,
      activeImageIndex: 0,
      currentPosition: {
        index: -1,
        audioId: '',
      },
      display: 'label', // 显示模式
      // 弹窗
      popupActive: '',
      popupData: {
        delete: {
          audioId: '',
          index: -1,
        },
        rename: {
          flag: '',
          index: -1,
          value: '',
        },
        uploadNoTip: false,
      },
      Placeholder: {
        picture02: require('../../../public/images/pretrain/placeholder-picture-02.png'),
        labelImg01: require('../../../public/images/pretrain/label001.png'),
        labelImg02: require('../../../public/images/pretrain/label002.jpg'),
      },
      Example: {
        labelAllImg: require('../../../public/images/pretrain/example_label_all.png'),
        labelSimilarImg: require('../../../public/images/pretrain/example_label_similar.png'),
      },
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
        edite: {
          iconName: '修改',
          viewBox: '0 0 17 17',
          width: '14',
          height: '14',
        },
        delete: {
          iconName: '删除',
          viewBox: '0 0 14 14',
          width: '14',
          height: '14',
          // iconColor: "#fff"}
        },
      },
      formdata: null,
      currentTextId: '',
      fullscreenLoading: null, // 加载效果
      navCheckList: ['全选', '全不选', '反选'],
      currentNavlabel: '全选',
      getTagLabelIdsNum: 0, // 统计标注数量
      updateTagNum: 0,
      drawerShow: false, // 引用数据集弹窗
    }
  },
  computed: {
    token() {
      return this.$store.state.token
    },
    modelType() {
      return this.$route.params.modeltype
    },
    filterOptData() {
      return this.filterOptions.items[this.filterOptions.filtered]
    },
    datasetOptions() {
      if (!this.DatasetList) {
        return []
      }

      return this.DatasetList.map((item) => {
        return { value: item.datasetName, label: item.datasetName }
      })
    },
    // 返回选中的音频
    regionAudio() {
      if (!this.activeImage) {
        return {}
      }

      return this.Pictures.records &&
        this.Pictures.records[this.activeImage.index]
        ? this.Pictures.records[this.activeImage.index]
        : {}
    },
    regionLabel() {
      return this.Label.records
    },
  },
  watch: {
    token() {
      this.getDatasetPageList() // // 获取数据集数据
    },
    datasetName(name) {
      // 重新初始化
      if (this.origin) {
        //origin=='modelList'场景时的判断
        this.ifIsRelease()
        this.origin = null
      } else {
        this.activeDataset = ''
      }
      this.getVersionList(name)
       
    },
    activeDataset() {
      // 重新初始化，如果没有重新初始化，会沿用上一个数据集内容
      this.displayChange(this.display, 1)

      this.activeLabel = [2]
      this.filterOptions.filtered = 'tag'
      this.filterOptions.items[this.filterOptions.filtered].filteredId = [2]

       this.ifIsRelease()

      this.getLabelList().then(() => {
        this.getPictureList()
        this.getLabelFilterOptions()
        this.setLabelStateAll() // 标签状态设置全选
      })
    },
    activeLabel(val) {
      var type = this.filterOptions.filtered

      if (type == 'tag') {
        // 获取查标注状态所有音频
        this.getPictureList()
      } else if (type == 'label') {
        // 获取标签筛选所有音频
        this.getPictureListByLabel()
      }
    },
    'filterOptions.filtered'(val) {
      this.activeImage.index = 0
    },
    Pictures(Pictures) {
      var index =
        this.activeImage && this.activeImage.index ? this.activeImage.index : 0
      this.currentPage = Pictures.current
      if (this.display === 'label') {
        this.currentPositionIndex = this.currentPage
      }

      if (Pictures.records) {
        if (Pictures.records.length < index + 1) {
          index = 0
        }
      } else {
        index = -1
      }

      this.activeImage = {
        audioId:
          Pictures.records && Pictures.records[index]
            ? Pictures.records[index].audioId
            : '',
        index: index,
      }
    },
    activeImage(val) {
      if (val.audioId !== this.currentTextId) {
        // 不同数据集激活
        this.currentTextId = val.audioId // 存储当前数据集
        // 获取激活音频的标记
        this.getImgTag()
      }
    },
    display(mode) {
      this.displayChange(mode)
      if (!this.activeDataset) {
        return
      }
      let pageIndex = 0
      let total = 0
      if (mode === 'picture') {
        // picture：展开多行列表
        if (this.currentPositionIndex > this.currentPage) {
          this.currentPage = this.currentPositionIndex
        }
        this.currentPositionIndex = this.currentPage // 展开多行页面存储单行页码
        localStorage.labelCurrentPage = this.currentPage
        total = (this.currentPage - 1) * 7 + this.activeImage.index + 1
        pageIndex = Math.ceil(total / 20)
        this.getCurrentTabNavAudioList(pageIndex) // 查询当前导航栏标签音频列表
        // 清除文件定位
        this.currentPosition = {
          index: -1,
          audioId: '',
        }
        this.activeImageIndex = this.activeImage.index // 展开多行页面存储单行当前下标
      } else {
        // label：展开单行列表
        if (this.currentPosition && this.currentPosition.audioId) {
          // 通过定位展开单行列表
          total = (this.currentPage - 1) * 20 + this.currentPosition.index + 1
          pageIndex = Math.ceil(total / 7)
          this.activeImage = {
            index: Math.floor((total - 1) % 7),
            audioId: this.currentPosition.audioId,
          }
          this.currentPositionIndex = pageIndex
        } else {
          // 通过收起多行列表按钮 展开单行列表
          pageIndex = Number(localStorage.labelCurrentPage)
          if (this.activeImageIndex > this.activeImage.index) {
            this.activeImage.index = this.activeImageIndex
          }
        }
        this.getCurrentTabNavAudioList(pageIndex) // 查询当前导航栏标签音频列表
      }
    },
  },
  mounted() {
    this.localStorageUploadTip()

    if (this.$route.query.datasetId) {
    this.datasetName = this.$route.query.datasetName
      this.origin = this.$route.query.origin
      this.originTemp = this.origin
      // 因引用数据集返回延迟-获取数据集id处理
      this.getVersionList(this.datasetName).then(() => {
        this.activeDataset = this.$route.query.datasetId
      })
    }
    if (this.$route.params.datasetId) {
       this.datasetName = this.$route.params.datasetName
      this.activeDataset = this.$route.params.datasetId
      this.origin = this.$route.params.origin
      this.originTemp = this.origin
    }

    if (this.token) {
      this.getDatasetPageList().then(() => {
        if (this.activeDataset) {
          this.getLabelList().then(() => {
            this.getPictureList()
          })
        }
      })
    }
  },
  methods: {
    // 标签状态设置全选
    setLabelStateAll() {
      this.Label.records.forEach((item) => {
        item.labelState = true
      })
      this.getImgTag() // 获取标注
    },
    // 标签全选、全不选、反选
    onSelectNavState(val) {
      this.currentNavlabel = val
      if (val === '全选') {
        this.setLabelStateAll() // 标签状态设置全选
      } else if (val === '全不选') {
        this.Label.records.forEach((item) => {
          item.labelState = false
        })
      } else {
        // 反选
        this.Label.records.forEach((item) => {
          item.labelState = !item.labelState
        })
      }
      this.$forceUpdate() // 强制更新数据
      // this.$refs.labelRegion.getText()
      this.getImgTag() // 获取标注
    },
    // 搜索标签
    onSearchLabel() {
      this.getLabelList()
      this.currentNavlabel = '全选'
    },
    // 搜索标注
    onSearchAnnotation() {
      let data = {
        audioId: this.activeImage.audioId,
        labelId: this.currentLabelId,
        tagValue: this.searchAnnotationName,
      }

      PRETRAIN.getTextTagByLabelId(data).then((result) => {
        if (
          result.returnCode === 200 &&
          result.data &&
          result.data.length !== 0
        ) {
          this.currentLabelList = result.data
        } else {
          this.currentLabelList = []
        }
      })
      // 标注搜索结果显示隐藏
      if (this.searchAnnotationName) {
        this.searchAnnotationNameFlng = true
      } else {
        this.searchAnnotationNameFlng = false
      }
    },
    // 点击定位到标注位置
    onCurrentTagValue(tagValue, textTagId) {
      this.$refs.labelRegion.onCurrentTextValue(tagValue, textTagId)
    },
    tagValueFilter(val) {
      let tagValue = ''
      if (val) {
        tagValue = val.replace(/<[^>]+>/g, '')
      }
      return tagValue
    },
    // 收起搜索标注 还原定位标注内嵌套的样式
    onDialogAnnotationShow() {
      this.dialogAnnotationShow = false
      this.$refs.labelRegion.onCurrentTextValue()
    },
    // 搜索标注弹窗
    onDialogAnnotation(labelId) {
      this.currentLabelId = labelId
      this.dialogAnnotationShow = true
      this.currentLabelList = []
      this.onSearchAnnotation()
    },
    // 音频定位
    onPreviewPosition(audioId, index) {
      this.currentPosition = {
        index: index,
        audioId: audioId,
      }
      this.display = 'label'
    },
    // 预览txt文件
    onFilePreview(audioUrl) {
      this.currentAudioUrl = this.photoBaseUrl + audioUrl
      this.dialogvisibleview = true
    },

    // 查询当前导航栏标签音频列表
    getCurrentTabNavAudioList(pageIndex) {
      let filtered = this.filterOptions.filtered
      if (filtered === 'tag') {
        // 根据数据集id查询音频列表
        this.getPictureList(pageIndex)
      } else if (filtered === 'label') {
        // 根据数据集id查询音频列表
        this.getPictureListByLabel(pageIndex)
        this.getTagNumByLabelIds() // 根据标签id查询标注数量
      }
    },
    // 获取数据集列表
    getDatasetPageList() {
      let data = {
        type: this.modelType,
      }

      return new Promise((resolve, reject) => {
        PRETRAIN.selectDataset(data).then((result) => {
          if (result.isSuccess) {
            this.DatasetList = result.data
            resolve(result.data)
          } else {
            reject(result)
          }
        })
      })
    },
       // 获取数据集版本列表
    getVersionList(datasetName) {
      let data = {
        type: this.modelType,
        datasetName,
      }
      return new Promise((resolve, reject) => {
        PRETRAIN.selectDatasetVersion(data).then((result) => {
          if (result.isSuccess) {
            this.versionList = result.data
            //origin=='dataList'场景时的判断
           this.ifIsRelease()
            resolve(result.data)
          } else {
            reject(result)
          }
        })
      })
    },
    //判断数据集版本是否已发布
    ifIsRelease(orgin) {
      let { origin, activeDataset, versionList } = this
      if (origin == 'modelList') {
        this.isRelease = 1
      } else if (versionList.length ) {
        versionList.forEach((item) => {
          if (item.datasetId == activeDataset) {
            this.isRelease = item.isRelease
          }
        })
      }
    },
    // 标签处理，标签最多 20 个
    // Label
    getLabelList() {
      var datasetId = this.activeDataset,
        data = {
          datasetId: datasetId,
          modelType: this.modelType,
          labelName: this.searchLabelName,
        }
      // debugger;
      return new Promise((resolve, reject) => {
        PRETRAIN.getLabelByDatasetId(data).then((result) => {
          if (result.isSuccess) {
            let records = JSON.parse(JSON.stringify(this.Label.records))
            this.Label.records = result.data

            if (this.currentNavlabel === '全选') {
              this.Label.records.forEach((item) => {
                item.labelState = true
              })
            } else if (this.currentNavlabel === '全不选') {
              this.Label.records.forEach((item) => {
                item.labelState = false
              })
            } else {
              // 反选
              this.Label.records.forEach((item) => {
                records.forEach((i) => {
                  if (item.labelId === i.labelId) {
                    item.labelState = i.labelState
                  }
                })
              })
              if (this.labelPopupTitle == '添加标签') {
                this.Label.records[0].labelState = true
              }
            }

            this.getImgTag() // 获取标注
            // this.Label = result.data;
            // this.activeLabel = result.Data.records[0].labelId;
            resolve(result.data)
          } else {
            reject(result)
          }
        })
      })
    },
    // 格式化标签筛选选项
    getLabelFilterOptions() {
      if (!this.Label.records) {
        return
      }

      this.filterOptions.items.label.data = this.Label.records.map((item) => {
        return {
          id: item.labelId,
          label: item.labelName,
        }
      })
      this.filterOptions.items.label.data.unshift({
        // id: "all_label",
        // label: "全部标签"
        id: 'all_picture',
        label: '全部音频',
      })
    },
    // 添加标签
    activeAddTagPopup(val) {
      this.labelPopupTitle = val
      // this.popupData.labelName = ''
      this.tagName = ''

      if (!this.activeDataset) {
        return this.$message.warning('请选择数据集再进行标签操作')
      }

      // 最多能创建 100 个标签分类
      if (this.Label.records && this.Label.records.length >= 100) {
        return this.$message.warning('最多只能创建 100 个标签分类')
      }

      this.popupActive = 'add_tag'
    },
    // 检测标题命名值
    checkLabelValue(value) {
      var result = false
      // eslint-disable-next-line no-useless-escape
      if (!/^[\u4e00-\u9fa5\_A-Za-z0-9]+$/.test(value)) {
        this.$message.error('标签名称只能由汉字、字母、数字组成')
        result = true
      }
      return result
    },
    // 创建标签
    addLabel() {
      // if (!this.tagName) {
      //   return this.$message.error('请输入标签名称');
      // } else
      if (this.checkLabelValue(this.tagName)) {
        // 标签命名检测，只能由汉字、字母、数字组成
        return
      }

      if (this.labelPopupTitle == '添加标签') {
        var datasetId = this.activeDataset,
          // labelName = this.popupData.labelName,
          labelName = this.tagName,
          data = {
            labelName: labelName,
            datasetId: datasetId,
          }

        PRETRAIN.addLabel(data).then(async (result) => {
          if (result.isSuccess) {
            this.$message.success(result.returnMsg)
            this.cancelPopup() // 关闭弹窗
            if (!this.Label.records) {
              this.Label.records = []
            }
            await this.getLabelList() //筛选标签列表更新
            this.getLabelFilterOptions() // 筛选标签列表更新
            this.popupData.labelName = '' // 清除缓存
            this.tagName = '' // 清除缓存
          } else {
            this.$message.error(result.returnMsg)
          }
        })
      }
      if (this.labelPopupTitle === '编辑标签') {
        this.renameLabel()
      }
    },
    // 标签重命名
    activeRenameLabelPopup(index, labelId, labelName) {
      // this.popupActive = 'rename'
      this.labelPopupTitle = '编辑标签'
      this.popupActive = 'add_tag'
      // this.popupData.labelNames = labelName
      this.tagName = labelName

      this.popupData.rename.index = index
      this.popupData.rename.value = labelName
      this.popupData.rename.flag = 'label'
    },
    renameLabel() {
      var index = this.popupData.rename.index,
        labelName = this.popupData.rename.value,
        label = this.Label.records[index],
        labelId = label.labelId,
        oldlabelName = label.labelName,
        datasetId = label.datasetId,
        data = {}

      // if (!this.tagName) {
      //   return this.$message.error('请输入标签名称')
      // } else
      if (this.checkLabelValue(this.tagName)) {
        // 标签命名检测，只能由汉字、字母、数字组成
        return
      }

      data = {
        labelName: this.tagName,
        labelId: labelId,
        datasetId: datasetId,
      }

      PRETRAIN.updateLabelBylabelId(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg)
          let iLabel = this.Label
          iLabel.records[index].labelName = this.tagName
          this.Label = iLabel
          // 关闭弹窗
          this.cancelPopup()
          this.getLabelList() //筛选标签列表更新
          this.getLabelFilterOptions() // 筛选标签列表更新
          // this.getImgTag() // 更新标注
          // 标记区域重命名
          this.$refs.labelRegion.renameRegionLabel(this.tagName, oldlabelName)
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
    // 删除标签弹窗
    deleteLabelPopup(index, labelId) {
      this.popupActive = 'label_delete'
      this.popupData.delete.index = index
    },
    // 删除标签
    deleteLabel(/*index, labelId*/) {
      var index = this.popupData.delete.index,
        label = this.Label.records[index],
        labelId = label.labelId,
        labelName = label.labelName,
        datasetId = label.datasetId,
        data = {},
        data2 = {}

      data = {
        labelName: labelName,
        labelId: labelId,
        datasetId: datasetId,
        datasetType: this.modelType,
      }
      data2 = {
        datasetId: datasetId,
      }

      // 先把文件里面的标注删除，然后把标签删除
      PRETRAIN.deleteLabelBylabelId(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg)
          // 关闭弹窗
          this.cancelPopup()
          PRETRAIN.getLabelByDatasetId(data2).then((res) => {
            if (res.isSuccess) {
              // 标签筛选选中处理
              let type = this.filterOptions.filtered,
                options = JSON.parse(JSON.stringify(this.filterOptions)),
                filteredIds = options.items[type].filteredId

              filteredIds.forEach((itm, idx) => {
                if (itm === labelId) {
                  filteredIds.splice(idx, 1) // 删除的标签从选中标签中去除
                }
              })
              this.filterOptions.items[type].filteredId = filteredIds
              this.activeLabel = filteredIds

              this.Label.records.splice(index, 1)
              this.getLabelFilterOptions() // 筛选标签列表更新
              this.sliderImageHandle(this.activeImage, this.activeImage.index) // 更新音频标注
              // this.getCurrentTabNavAudioList(this.Pictures.current); // 查询当前导航栏标签音频列表
              this.getImgTag() // 更新标注

              // 删除标签透同步删除标记区域
              this.$refs.labelRegion.deleteRegionLabel(labelName)
            } else {
              this.$message.error(res.returnMsg)
            }
          })
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },

    // 根据标签id查询标注数量
    getTagNumByLabelIds() {
      var datasetId = this.activeDataset,
        data = {},
        activeLabel = JSON.parse(JSON.stringify(this.activeLabel)),
        labels = activeLabel.map((item) => {
          return item
        })

      if (!this.activeDataset /*|| this.activeLabel.length <= 0*/) {
        return
      }

      // 全部音频
      if (activeLabel.includes('all_picture')) {
        labels = []
      }

      data = {
        datasetId: datasetId, // 数据集id
        datasetType: this.modelType, // 数据集类型（同模型类型：modelType）
        isQualified: this.selectCondition, // 条件筛选 0：全部；1:符合条件；2:不符合条件
        labelIdList: labels, // 标签id集合
      }

      PRETRAIN.getTagNumByLabelIds(data).then((result) => {
        if (result.isSuccess) {
          this.getTagLabelIdsNum = result.data
        }
      })
    },

    // 根据数据集id查询音频列表
    // tips:音频标注中，需要数据集和分类标签完备情况下使用
    getPictureList(pageIndex) {
      var pageIndex_ = pageIndex ? pageIndex : 1,
        pageSize = this.Pictures.size,
        data = {}

      if (!this.activeDataset) {
        return
      }

      data = {
        datasetId: this.activeDataset,
        pageNum: pageIndex_,
        pageSize: pageSize,
      }

      // TODO:此处可优化
      if (this.activeLabel.length > 0) {
        if (this.filterOptions.filtered === 'tag') {
          data.isTag = this.activeLabel[0]
        }
      }

      return new Promise((resolve, reject) => {
        PRETRAIN.getAudioByDatasetId(data).then((result) => {
          if (result.isSuccess) {
            if (result.data) {
              this.Pictures = result.data
            }

            // 当前页没有音频回调去到上一页
            if (
              this.Pictures &&
              this.Pictures.current > 1 &&
              this.Pictures.records.length === 0
            ) {
              let currentPageNum = this.Pictures.current - 1
              this.getPictureList(currentPageNum)
            }
            resolve(result.data)
          } else {
            reject(result)
          }
        })
      })
    },
    // 通过标签标注获取音频
    getPictureListByLabel(pageIndex) {
      var pageNum = pageIndex ? pageIndex : 1,
        pageSize = this.Pictures.size,
        datasetId = this.activeDataset,
        data = {},
        activeLabel = JSON.parse(JSON.stringify(this.activeLabel)),
        labels = activeLabel.map((item) => {
          return item
        })

      if (!this.activeDataset /*|| this.activeLabel.length <= 0*/) {
        return
      }

      // 全部音频
      if (activeLabel.includes('all_picture')) {
        labels = []
      }

      data = {
        labelIdList: labels,
        datasetId: datasetId,
        pageNum: pageNum,
        pageSize: pageSize,
      }

      return new Promise((resolve, reject) => {
        PRETRAIN.getAudioByLabelIdList(data).then((result) => {
          if (result.isSuccess) {
            this.Pictures = result.data

            // 当前页没有音频回调去到上一页
            if (
              this.Pictures &&
              this.Pictures.current > 1 &&
              this.Pictures.records.length === 0
            ) {
              let currentPageNum = this.Pictures.current - 1
              this.getPictureListByLabel(currentPageNum)
            }
            resolve(result.data)
          } else {
            reject(result)
          }
        })
      })
    },

    // 引用数据集
    quoteDataset() {
      this.drawerShow = true // 打开数据集弹窗
    },
    // 文件上传
    uploadPictures() {
      if (this.Pictures.total >= 3000) {
        return this.$message.error('单个数据集的音频总数不超过3000个哦~')
      }
      // TODO: 数据集选定、分类标签选定
      if (!this.popupData.uploadNoTip) {
        // 文件限制数据提示弹窗
        this.activeUploadTipPopup()
      } else {
        // 直接上传
        this.uploadPicturesToDataset()
      }
    },
    // 上传文件到相应标签的数据集中
    uploadPicturesToDataset() {
      var uploadFileNode = document.createElement('input'), // 创建上传按钮
        fileList = [], // 文件列表
        self = this

      uploadFileNode.setAttribute('type', 'file') // 设置上传按钮属性
      uploadFileNode.setAttribute('multiple', 'ture') // 多文件上传
      uploadFileNode.setAttribute('accept', '.mp3, .wav') // 限制.mp3|.wav音频除外的文件上传
      // uploadFileNode.setAttribute("enctype", "multipart/form-data;"); // 编码方式

      uploadFileNode.click() // 触发上传事件

      // 上传进程
      uploadFileNode.onchange = function uploadChange(evt) {
        var formdata = new FormData(),
          list,
          formatPass = true

        // 文件装配
        fileList = evt.target.files
        list = Array.from(fileList)

        if (list.length > 200) {
          return self.$message.error('上传失败，单次上传音频限制200个!')
        }

        if (self.Pictures.total + list.length > 3000) {
          return self.$message.error(
            '上传失败，单个数据集的音频总数不超过3000个哦~'
          )
        }

        // formatPass = self.$util.filesFormatCheck(list, 'mp3|MP3|wav|WAV');
        // if (formatPass) {
        //   return self.$message.error('上传失败，请上传格式为 wav/mp3 的音频！');
        // }

        let noFile = 0
        list.forEach(async (file) => {
          let typeFlag = self.$util.filesFormatCheck(file, 'mp3|MP3|wav|WAV')
          if (typeFlag) {
            noFile++
            self.$message.error(
              `${file.name}上传失败，请上传格式为 wav/mp3 的音频！`
            )
          } else if (file.size > 5242880) {
            noFile++
            self.$message.error(`上传失败，音频名称为${file.name}格式过大！`)
          } else {
            formdata.append('file', file)
          }
        })
        if (list.length === noFile) {
          return
        }

        self.fullscreenLoading = self.$loading({
          lock: true,
          text: '音频上传中请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })

        setTimeout(() => {
          COMMON.UploadMultipleFile(formdata)
            .then((result) => {
              var data = {
                datasetId: self.activeDataset,
                datasetAudioList: [],
                // labelId: self.activeLabel
              }
              if (result.returnCode === 200) {
                data.datasetAudioList = result.data.map((item) => {
                  return {
                    audioUrl: item.url,
                    audioName: item.fileName,
                  }
                })
                // 批量上传文件地址
                PRETRAIN.uploadAudio(data)
                  .then((result) => {
                    if (result.isSuccess) {
                      // 上传成功
                      self.$message.success(result.returnMsg)
                      self.fullscreenLoading.close() // 关闭Loading
                      // TODO:刷新音频数据
                      self.getCurrentTabNavAudioList() // 查询当前导航栏标签音频列表
                      uploadFileNode = null // 移除上传元素
                      formdata = null // 释放
                      fileList = [] // 释放
                    } else {
                      self.$message.error(result.returnMsg)
                      self.fullscreenLoading.close() // 关闭Loading
                    }
                  })
                  .catch((error) => {
                    self.fullscreenLoading.close() // 关闭Loading
                  })
              } else {
                self.$message.error(result.returnMsg)
                self.fullscreenLoading.close() // 关闭Loading
              }
            })
            .catch((error) => {
              self.fullscreenLoading.close() // 关闭Loading
            })
        }, 100)
      }
    },

    // 删除音频/标签
    deletePicture() {
      if (this.popupActive === 'delete') {
        // 删除音频操作
        this.deleteAudio()
      } else if (this.popupActive === 'label_delete') {
        // 删除标签操作
        this.deleteLabel()
      }
    },
    // 删除音频
    deleteAudio() {
      var deleteIndex = this.popupData.delete.index,
        audio = this.Pictures.records[deleteIndex],
        data = {
          audioId: audio.audioId,
          audioName: audio.audioName,
        }

      PRETRAIN.deleteAudioByAudioId(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success('已删除音频：' + audio.audioName)
          this.getCurrentTabNavAudioList(this.Pictures.current) // 查询当前导航栏标签音频列表
          this.cancelPopup() // 关闭弹窗
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
    // 音频重命名
    renamePicture() {
      if (!this.popupData.rename.value) {
        return this.$message.error('重命名不能为空！')
      }
      if (this.popupData.rename.value.length > 20) {
        return this.$message.error('重命名不能超过20个字符！')
      }

      var renameIndex = this.popupData.rename.index,
        audioName = this.popupData.rename.value,
        text = this.Pictures.records[renameIndex],
        data = {
          audioId: text.audioId,
          audioName: audioName,
        },
        list = []

      PRETRAIN.updateAudioByAudioId(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg)
          list = JSON.parse(JSON.stringify(this.Pictures.records))
          list[renameIndex].audioName = audioName
          this.popupData.rename.value = ''
          this.Pictures.records = list
          this.cancelPopup() // 关闭弹窗
        }
      })
    },
    // 模型音频标注
    getImgTag() {
      if (!this.activeDataset) {
        return
      }
      var audioId = this.activeImage.audioId,
        datasetId = this.activeDataset,
        data = {
          audioId: audioId,
          labelIds: [],
        }

      this.Label.records.forEach((item) => {
        if (item.labelState) {
          data.labelIds.push(item.labelId)
        }
      })

      if (!audioId) {
        return
      }

      // 根据音频id查询音频标注数据-音频标注 @data audioId：音频id
      PRETRAIN.getAudioTagByAudioId(data).then((result) => {
        if (
          result.returnCode === 200 &&
          result.data &&
          result.data.length !== 0
        ) {
          this.annotationsList = result.data
        } else {
          this.annotationsList = []
        }
      })
    },
    // 关闭弹窗
    cancelPopup() {
      this.popupActive = ''
      // TODO: popupData 考虑是否要清除
    },
    // 标注示例
    activeExamplePopup() {
      this.popupActive = 'example'
    },
    // 删除
    activeDeletePopup(audioId, index) {
      this.popupActive = 'delete'
      this.popupData.delete.audioId = audioId
      this.popupData.delete.index = index
    },
    // 重命名
    activeRenamePopup(audioId, audioName, index) {
      this.popupActive = 'rename'
      // this.popupData.rename = "pictureName";
      this.popupData.rename.flag = 'picture'
      this.popupData.rename.value = audioName
      this.popupData.rename.index = index
    },
    renameOperate() {
      // 在弹窗数据中，存放 flag
      if (this.popupData.rename.flag === 'label') {
        this.renameLabel()
      } else if (this.popupData.rename.flag === 'picture') {
        this.renamePicture()
      }
    },
    // 音频上传说明
    activeUploadTipPopup() {
      this.popupActive = 'uploadtip'
    },
    // 上传提示显示后再进行上传操作
    confirmUploadTip() {
      // 音频上传说明确认
      this.cancelPopup()
      // TODO:上传音频事件触发
      this.uploadPicturesToDataset()
    },
    uploadNoTipChange(val) {
      this.localStorageUploadTip('save', val)
    },
    // 音频上传说明是否显示存储
    localStorageUploadTip(type, value) {
      if (type === 'save') {
        // TODO:
        this.popupData.uploadNoTip = value
        window.localStorage.setItem('__upload_audioAnnotation_tip__', value)
      } else {
        let uploadNoTip = window.localStorage.getItem(
          '__upload_audioAnnotation_tip__'
        )
        this.popupData.uploadNoTip = uploadNoTip ? uploadNoTip : false
      }
    },
    // 筛选方式获取
    getFilterType(type) {
      this.filterOptions.filtered = type

      this.activeLabel = this.filterOptions.items[
        this.filterOptions.filtered
      ].filteredId

      this.getTagNumByLabelIds() // 根据标签id查询标注数量
      this.getTagLabelIdsNum = 0
      this.setLabelStateAll() // 标签状态设置全选
    },
    // 筛选详细
    getFilterDetails(filterId) {
      var type = this.filterOptions.filtered,
        options = JSON.parse(JSON.stringify(this.filterOptions)),
        filteredIds = options.items[this.filterOptions.filtered].filteredId,
        currentFileterIdx = filteredIds.findIndex((item) => item === filterId)

      // 情形分管
      if (type === 'label') {
        // 标签筛选
        if (currentFileterIdx <= -1) {
          filteredIds[filteredIds.length] = filterId
        } else {
          filteredIds.splice(currentFileterIdx, 1)
        }
        options.items[this.filterOptions.filtered].filteredId = filteredIds
        this.filterOptions = options

        this.activeLabel = filteredIds
      } else if (type === 'tag') {
        // 音频筛选
        options.items[this.filterOptions.filtered].filteredId[0] = filterId
        this.filterOptions = options

        this.activeLabel = [filterId]
      }

      this.getTagNumByLabelIds() // 根据标签id查询标注数量
      this.setLabelStateAll() // 标签状态设置全选
    },
    // 移除筛选详细
    removeFilterDetails(idx, filterId) {
      // item.id
      var type = this.filterOptions.filtered,
        options = JSON.parse(JSON.stringify(this.filterOptions)),
        filteredIds = options.items[this.filterOptions.filtered].filteredId,
        currentFileterIdx = filteredIds.findIndex((item) => item === filterId)

      if (type === 'label') {
        if (currentFileterIdx > -1) {
          filteredIds.splice(currentFileterIdx, 1)

          options.items[this.filterOptions.filtered].filteredId = filteredIds
          this.filterOptions = options

          this.activeLabel = filteredIds
        }
      } else if (type === 'tag') {
        options.items[this.filterOptions.filtered].filteredId[0] = 2
        this.filterOptions = options

        this.activeLabel = [2]
      }
    },
    // 把标签添加到当前区域
    addTagToCurrentRegion(labelName, labelId, labelData) {
      this.selentCurrentLabelId = labelId
      this.$refs.labelRegion.addLabelSelect(labelData) // 调用选中标签
    },
    onSelectLabel(labelId) {
      this.Label.records.forEach((item) => {
        if (item.labelId === labelId) {
          item.labelState = !item.labelState
        }
      })
      this.$forceUpdate() // 强制更新数据
      // this.$refs.labelRegion.getText();
      this.getImgTag() // 获取标注
    },
    // 上传标签标记
    updateLabelTag() {
      if (this.updateTagNum === 0) {
        // 判断连接点击多次保存只执行第一次
        this.updateLabelTagToOne()
      }
      this.updateTagNum++
    },
    // 00000000-0000-0000-0000-000000000000
    updateLabelTagToOne() {
      let audioTagList = this.$refs.labelRegion.getAudioList(), // 获取音频数据列表
        audioObj = {},
        data = {
          list: [],
          audioId: this.activeImage.audioId,
        }

      audioTagList.forEach((item) => {
        audioObj = {
          audioId: this.activeImage.audioId,
          labelId: item.labelId,
          startTime: item.startTime,
          endTime: item.endTime,
        }
        data.list.push(audioObj)
      })

      // 根据音频id标注音频
      PRETRAIN.updateAudioTagByAudioId(data)
        .then((result) => {
          if (result.isSuccess) {
            this.$message.success('保存成功')
            let filtered = this.filterOptions.filtered
            if (filtered === 'tag') {
              // 标注状态
              if (
                this.activeLabel[0] === 0 ||
                (this.activeLabel[0] === 1 && audioTagList.length === 0)
              ) {
                // 未标注 || 已标注
                this.getCurrentTabNavAudioList(this.Pictures.current) // 查询当前导航栏标签音频列表
              }
            } else if (filtered === 'label') {
              // 标签筛选
              if (
                this.activeLabel.length &&
                !this.activeLabel.includes('all_picture')
              ) {
                // 判断非全部音频（标签标注分类）
                this.getCurrentTabNavAudioList(this.Pictures.current) // 查询当前导航栏标签音频列表
              }
              this.getTagNumByLabelIds() // 根据标签id查询标注数量
            }

            setTimeout(() => {
              this.getImgTag() // 重新获取标注
            }, 100)
          } else {
            this.$message.error(result.returnMsg)
          }
          this.updateTagNum = 0 // 重置保存点击次数
        })
        .catch((err) => {
          this.updateTagNum = 0 // 重置保存点击次数
        })
    },
    // 利用标注名获取标注 id
    findLabelBylabelName(labelName) {
      var label = {}
      if (labelName === '无目标') {
        label = { labelId: '00000000-0000-0000-0000-000000000000' }
      } else {
        label = this.Label.records.find(
          (label) => label.labelName === labelName
        )
      }
      return label
    },
    // 音频滑动
    sliderPrev(/*direct , evt */) {
      let { Pictures } = this
      if (Pictures.current && Pictures.current > 1) {
        this.pageTurnApi(-1)
      }
      this.currentPositionIndex = this.currentPage
    },
    sliderNext(/*direct , evt */) {
      this.currentPositionIndex = this.currentPage
      if (
        this.Pictures.current &&
        this.Pictures.current < this.Pictures.pages
      ) {
        this.pageTurnApi(1)
      } else {
        return
      }
    },
    // 音频滑动/点击触发
    sliderImageHandle(audio, index) {
      this.activeImage = { audioId: audio.audioId, index: index }
      this.dialogAnnotationShow = false
      this.selentCurrentLabelId = '' // 清除选中标签背景
      this.$refs.labelRegion.addLabelSelect({}) // 调用选中标签：清除选中标签
    },
    pageTurnApi(type) {
      var key = 1 * type
      this.getCurrentTabNavAudioList(this.Pictures.current + key) // 查询当前导航栏标签音频列表
    },
    // 分页器
    handleCurrentChange(pageIndex) {
      this.getCurrentTabNavAudioList(pageIndex) // 查询当前导航栏标签音频列表
    },
    // 切换页面格式
    switchDisplayMode() {
      var mode = this.display
      this.display = mode === 'label' ? 'picture' : 'label'
      // 获取模型音频标注
      this.getImgTag()
    },
    displayChange(mode, init) {
      var display = {
          picture: { size: 20, current: 1 },
          label: {
            size: 7,
            current: 1,
          },
        },
        p = { records: [], total: 0 }

      if (init) {
        this.Pictures = Object.assign(p, display[mode])
      } else {
        Object.assign(this.Pictures, display[mode])
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './pretrain_common.scss';
@import './DatasetAudioAnnotation.scss';
</style>
